const { NIMBUS_DATA_TYPES } = require('../nimbus-data-types');

module.exports = {
  displayName: 'GRN LR Upload',
  description: 'GRN LR Upload Settings',
  sortOrder: 1,
  name: 'grn_lr_upload',
  documentKey: 'grn_lr_upload',
  values: {
    shipper_upload_LR_inbound: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'shipper_upload_LR_inbound',
      documentKey: 'shipper_upload_LR_inbound',
    },
    shipper_upload_LR_outbound: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'shipper_upload_LR_outbound',
      documentKey: 'shipper_upload_LR_outbound',
    },
    lr_attachment_required: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'lr_attachment_required',
      documentKey: 'lr_attachment_required',
    },
    is_grn_enabled_for_transporter: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'is_grn_enabled_for_transporter',
      documentKey: 'is_grn_enabled_for_transporter',
    },
    grn_file_path: {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: '',
      displayName: 'grn_file_path',
      documentKey: 'grn_file_path',
    },
  },
};
